import { Component, OnInit, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import FileSaver from 'file-saver';
import { BehaviorSubject, Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

import { SnackBarConfig } from '../../../shared';
import { PicklistApiService } from '../../../shared/services/api/picklist-api.service';
import { EPackingSlipPageSize } from '../../interfaces/shipping.interface';

@Component({
  selector: 'lum-shipping-label-with-packing-slip-popup',
  templateUrl: './shipping-label-with-packing-slip-popup.component.html',
  styleUrls: ['./shipping-label-with-packing-slip-popup.component.scss'],
})
export class ShippingLabelWithPackingSlipPopupComponent {
  ePageSize = EPackingSlipPageSize;
  packingSlipPageSize :string = EPackingSlipPageSize.A4;

  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  loading$ = this._loading.asObservable();

  private onDestroy$ = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data :{
      salesOrderIds :number[];
    },
    private dialogRef :MatDialogRef<ShippingLabelWithPackingSlipPopupComponent>,
    private picklistApiService :PicklistApiService,
    private snackbar :MatSnackBar,
  ) {}

  onClose() :void {
    this.dialogRef.close();
  }

  onSubmit() :void {
    const salesOrderIds = this.data.salesOrderIds.join(',');

    this._loading.next(true);
    this.picklistApiService
      .exportLabelsWithPackingSlip({
        salesOrderIds,
        packingSlipPageSize: this.packingSlipPageSize,
      })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => {
          this._loading.next(false);
          this.onClose();
        }),
      )
      .subscribe({
        next: (response) => {
          FileSaver.saveAs(response, 'labels-w-packing-slip.pdf');
        },
        error: (error) => {
          this.snackbar.open(
            'Error exporting shipping labels with packing slip.',
            'Error',
            {
              duration: SnackBarConfig.DEFAULT.duration,
            },
          );
        },
      });
  }
}
